// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TradePartnerReviewsQueryVariables = Types.Exact<{
  tradePartnerId: Types.Scalars['ID']['input'];
}>;


export type TradePartnerReviewsQuery = { __typename?: 'Query', tradePartner: { __typename?: 'TradePartner', id: string, reviews: Array<{ __typename?: 'TradePartnerReview', id: string, createdAt: Types.Scalars['DateTime']['input'], score: number, recommended?: boolean | null | undefined, internalNote?: string | null | undefined, internalUser: { __typename?: 'InternalUser', id: string, name: string }, project: { __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string } }> }, internalUsers: Array<{ __typename?: 'InternalUser', id: string, name: string }>, projects: Array<{ __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string }> };

export type SaveTradePartnerReviewMutationVariables = Types.Exact<{
  input: Types.SaveTradePartnerReviewInput;
}>;


export type SaveTradePartnerReviewMutation = { __typename?: 'Mutation', saveTradePartnerReview: { __typename?: 'SaveTradePartnerReviewResult', tradePartnerReview: { __typename?: 'TradePartnerReview', id: string, createdAt: Types.Scalars['DateTime']['input'], score: number, recommended?: boolean | null | undefined, internalNote?: string | null | undefined, tradePartner: { __typename?: 'TradePartner', id: string, reviews: Array<{ __typename?: 'TradePartnerReview', id: string }> }, internalUser: { __typename?: 'InternalUser', id: string, name: string }, project: { __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string } } } };

export type ReviewTabReviewFragment = { __typename?: 'TradePartnerReview', id: string, createdAt: Types.Scalars['DateTime']['input'], score: number, recommended?: boolean | null | undefined, internalNote?: string | null | undefined, internalUser: { __typename?: 'InternalUser', id: string, name: string }, project: { __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string } };

export const ReviewTabReviewFragmentDoc = gql`
    fragment ReviewTabReview on TradePartnerReview {
  id
  createdAt
  score
  recommended
  internalUser {
    id
    name
  }
  project {
    id
    name
  }
  internalNote
}
    `;
export const TradePartnerReviewsDocument = gql`
    query TradePartnerReviews($tradePartnerId: ID!) {
  tradePartner(id: $tradePartnerId) {
    id
    reviews {
      ...ReviewTabReview
    }
  }
  internalUsers {
    id
    name
  }
  projects {
    id
    name
  }
}
    ${ReviewTabReviewFragmentDoc}`;

/**
 * __useTradePartnerReviewsQuery__
 *
 * To run a query within a React component, call `useTradePartnerReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradePartnerReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradePartnerReviewsQuery({
 *   variables: {
 *      tradePartnerId: // value for 'tradePartnerId'
 *   },
 * });
 */
export function useTradePartnerReviewsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TradePartnerReviewsQuery, TradePartnerReviewsQueryVariables> & ({ variables: TradePartnerReviewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradePartnerReviewsQuery, TradePartnerReviewsQueryVariables>(TradePartnerReviewsDocument, options);
      }
export function useTradePartnerReviewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradePartnerReviewsQuery, TradePartnerReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradePartnerReviewsQuery, TradePartnerReviewsQueryVariables>(TradePartnerReviewsDocument, options);
        }
// @ts-ignore
export function useTradePartnerReviewsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TradePartnerReviewsQuery, TradePartnerReviewsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradePartnerReviewsQuery, TradePartnerReviewsQueryVariables>;
export function useTradePartnerReviewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradePartnerReviewsQuery, TradePartnerReviewsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradePartnerReviewsQuery | undefined, TradePartnerReviewsQueryVariables>;
export function useTradePartnerReviewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradePartnerReviewsQuery, TradePartnerReviewsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TradePartnerReviewsQuery, TradePartnerReviewsQueryVariables>(TradePartnerReviewsDocument, options);
        }
export type TradePartnerReviewsQueryHookResult = ReturnType<typeof useTradePartnerReviewsQuery>;
export type TradePartnerReviewsLazyQueryHookResult = ReturnType<typeof useTradePartnerReviewsLazyQuery>;
export type TradePartnerReviewsSuspenseQueryHookResult = ReturnType<typeof useTradePartnerReviewsSuspenseQuery>;
export type TradePartnerReviewsQueryResult = Apollo.QueryResult<TradePartnerReviewsQuery, TradePartnerReviewsQueryVariables>;
export const SaveTradePartnerReviewDocument = gql`
    mutation SaveTradePartnerReview($input: SaveTradePartnerReviewInput!) {
  saveTradePartnerReview(input: $input) {
    tradePartnerReview {
      ...ReviewTabReview
      tradePartner {
        id
        reviews {
          id
        }
      }
    }
  }
}
    ${ReviewTabReviewFragmentDoc}`;
export type SaveTradePartnerReviewMutationFn = Apollo.MutationFunction<SaveTradePartnerReviewMutation, SaveTradePartnerReviewMutationVariables>;

/**
 * __useSaveTradePartnerReviewMutation__
 *
 * To run a mutation, you first call `useSaveTradePartnerReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTradePartnerReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTradePartnerReviewMutation, { data, loading, error }] = useSaveTradePartnerReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTradePartnerReviewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveTradePartnerReviewMutation, SaveTradePartnerReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveTradePartnerReviewMutation, SaveTradePartnerReviewMutationVariables>(SaveTradePartnerReviewDocument, options);
      }
export type SaveTradePartnerReviewMutationHookResult = ReturnType<typeof useSaveTradePartnerReviewMutation>;
export type SaveTradePartnerReviewMutationResult = Apollo.MutationResult<SaveTradePartnerReviewMutation>;
export type SaveTradePartnerReviewMutationOptions = Apollo.BaseMutationOptions<SaveTradePartnerReviewMutation, SaveTradePartnerReviewMutationVariables>;